import { SectionLabel } from "@/components/Motion";

/* ============================================================
   PASTE THE FINAL APPROVED PRIVACY POLICY TEXT BELOW.
   Whatever you put inside the backticks renders EXACTLY as
   written — line breaks, blank lines and indentation are all
   preserved. Do not remove the backticks.
   ============================================================ */
const PRIVACY_POLICY_TEXT = `Privacy Policy
Last updated: August 2026
The Safe Mama Editorial is published by Banyan Editorials, a proprietorship currently in the process of registration in India.
We care about your privacy and believe you should understand what information we collect, why we collect it, and how we use it.
This Privacy Policy applies when you visit The Safe Mama Editorial website, purchase an edition or plan, join our mailing list, contact us, manage your plan, or otherwise interact with us.
1. Information We Collect
Depending on how you use The Safe Mama Editorial, we may collect information such as:
Your name
Email address
Phone number
Postal and delivery address
Whether you have selected the Pregnancy Edition or Motherhood Edition
Interests or preferences you choose to share with us
Your selected plan and order history
Delivery and fulfilment information
Communications you send to us
Newsletter preferences
Technical information generated when you use our website, such as device, browser and basic website usage information
We aim to collect only the information reasonably necessary to provide and improve The Safe Mama Editorial.
2. Payment Information
Payments may be processed through a third-party payment provider such as Razorpay.
Your payment information may therefore be collected and processed directly by the payment provider in accordance with its own privacy and security practices.
The Safe Mama Editorial does not intend to store your complete card, bank account or other sensitive payment credentials on its own systems.
3. How We Use Your Information
We may use your information to:
Process your purchase
Deliver The Safe Mama Editorial to you
Determine whether to send you the Pregnancy or Motherhood Edition
Manage your plan and remaining editions
Process pauses and resumptions
Allow you to update your delivery information or preferences
Communicate important information about your order or delivery
Respond to questions and customer-support requests
Maintain records relating to orders and fulfilment
Improve our website and reader experience
Prevent fraud, misuse or security issues
Comply with applicable legal obligations
4. Marketing & The Safe Mama Newsletter
Purchasing The Safe Mama Editorial does not automatically subscribe you to marketing emails or our newsletter.
Where we offer newsletters, editorial emails or other optional communications, you can choose separately whether you would like to receive them.
You may unsubscribe from optional marketing communications at any time.
We may still send essential transactional communications relating to a purchase you have made, such as order confirmations, delivery information or important changes affecting your plan.
5. Share Your Story
The Safe Mama Editorial invites mothers to voluntarily share experiences from pregnancy, postpartum and motherhood through our separate story-submission process.
Story submissions are subject to the permissions and information provided at the point of submission.
Where a story is selected for publication, it may be edited, rewritten and anonymised in accordance with the consent provided through the submission form.
We take the privacy of these submissions seriously and will not intentionally publish information identifying a contributor unless we have received appropriate permission to do so.
Sharing a story is entirely voluntary and is separate from purchasing The Safe Mama Editorial.
6. Who We Share Information With
We may share necessary information with trusted service providers who help us operate The Safe Mama Editorial, including providers involved in:
Payment processing
Website hosting and technology
Order management
Email communications
Printing, packaging and fulfilment
Shipping and delivery
Analytics and website security
We only share information that is reasonably necessary for them to perform the relevant service.
We may also disclose information where required by applicable law, regulation, legal process or governmental request.
We do not sell your personal information.
7. External Links & The Reading Room
The Reading Room may include links to articles, publications and resources hosted by third-party websites.
When you follow an external link, you leave The Safe Mama Editorial website. The privacy practices of that external website will be governed by its own privacy policy.
The Safe Mama Editorial is not responsible for the privacy practices of third-party websites.
8. How Long We Keep Your Information
We retain personal information only for as long as reasonably necessary for the purposes for which it was collected, including fulfilling orders, maintaining appropriate business and financial records, resolving disputes, and meeting applicable legal obligations.
Where information is no longer reasonably required, we may delete or anonymise it, subject to any legal record-keeping requirements.
9. Your Choices & Rights
Subject to applicable law, you may contact us to request assistance with your personal information, including correcting inaccurate information or requesting deletion of information that we are not legally required to retain.
You can also update certain delivery details and preferences through the plan-management features available on our website, where applicable.
For privacy-related requests, contact:
thesafemamaeditorial@gmail.com
We may need to verify that the request relates to you before making certain changes.
10. Security
We use reasonable administrative and technical measures intended to protect personal information.
However, no website, database or method of electronic transmission can be guaranteed to be completely secure.
11. Children's Privacy
The Safe Mama Editorial is intended for adults.
Our services are not intended to collect personal information directly from children.
Please avoid providing unnecessary identifying information about children when communicating with us or submitting information through the website.
12. Changes to This Policy
We may update this Privacy Policy as The Safe Mama Editorial evolves or where legal or operational requirements change.
The latest version will be published on our website with its updated date.
13. Contact Us
For privacy questions or requests, please contact:
The Safe Mama Editorial
Published by Banyan Editorials
Email: thesafemamaeditorial@gmail.com
India`;
/* ============================================================
   END OF EDITABLE CONTENT.
   ============================================================ */

export default function PrivacyPolicy() {
  return (
    <div className="pt-10 md:pt-16 pb-32" data-testid="privacy-policy-page">
      <section className="editorial-container max-w-3xl">
        <SectionLabel number="Legal" label="Privacy Policy" />
        <h1 className="mt-8 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink">
          Privacy Policy
        </h1>

        <div
          className="mt-14 font-sans text-base md:text-lg leading-[1.75] text-ink/85 whitespace-pre-wrap"
          data-testid="privacy-policy-body"
        >
          {PRIVACY_POLICY_TEXT}
        </div>
      </section>
    </div>
  );
}
